import { useState } from "react";
import { Domains } from "../data/Domains";
import { NotificationTypes } from "../data/NotificationTypes";
import VillageConsoleContext from "./VillageConsoleContext";


type VillageConsoleProviderProviderProps = {children: React.ReactNode};


const VillageConsoleProvider = ( {children} : VillageConsoleProviderProviderProps ) => {

  const [ availableDomains, setAvailableDomains ] = useState<Domains[]>( [] );
  const [ domain, setDomain ] = useState< Domains >( Domains.Bma );
  const [ functionKey, setFunctionKey ] = useState<string|null>(  null );

  const [ notificationMessage, setNotificationText ] = useState<string>( '' );
  const [ notificationType, setNotificationType ] = useState<NotificationTypes>( NotificationTypes.Success );
  const [ readonlyDomains, setReadonlyDomains ] = useState<Domains[]>( [] );

  const setAvailableDomainsHandler = ( domains: Domains[] ) => setAvailableDomains( domains );
  const setDomainHandler = ( domain: Domains ) => setDomain( domain );
  const setFunctionKeyHandler = ( functionKey: string|null) => setFunctionKey( functionKey );
  const setNotificationTextHandler = ( notificationMessage:string ) => setNotificationText( notificationMessage ); 
  const setNotificationTypeHandler = (notificationType: NotificationTypes ) => setNotificationType( notificationType );
  const setReadonlyDomainsHandler = ( domains: Domains[] ) => setReadonlyDomains( domains );

  return (
    <VillageConsoleContext.Provider value = {{
      availableDomains
      , domain
      , functionKey
      , notificationMessage
      , notificationType
      , readonlyDomains
      , setAvailableDomains: setAvailableDomainsHandler
      , setDomain: setDomainHandler
      , setFunctionKey: setFunctionKeyHandler
      , setNotificationText: setNotificationTextHandler
      , setNotificationType: setNotificationTypeHandler
      , setReadonlyDomains: setReadonlyDomainsHandler
    }}>
      {children}
    </VillageConsoleContext.Provider>
  );

}

export default VillageConsoleProvider;